export const routesPersonel = [
  {
    path: "/personel",
    name: "personel",
    component: () => import("@/views/personel/personel/index.vue"),
    meta: {
      public: false,
      title: "Personel",
      yetki: { k: [1013102] },
    },
  },
  {
    path: "/personel/:userId",
    name: "personel_profil",
    component: () => import("@/views/personel/personel/profil/index.vue"),
    meta: {
      public: false,
      title: "personel.Personel Profil",
      yetki: { k: [1013104] },
    },
  },
]
